// extracted by mini-css-extract-plugin
export default {"wrapper":"Icon_wrapper__I6Cew","fullSize":"Icon_fullSize__qNn+6"};